import React, { lazy, Suspense } from 'react';
import SEO from './../shared/SEO/SEO';
import Loading from './../shared/Loading/Loading';
import './styles.css';

const Quality = lazy(() => import('./quality/Quality'));
const Consultation = lazy(() => import('./consultation/Consultation'));
const Showcase = lazy(() => import('./showcase/Showcase'));
const CommercialShowcase = lazy(() => import('./showcase/CommercialShowcase'));

const Home = ({ isMobile }) => {

  return (
    <>
      <SEO
        title={`SunbowShades | Making Premium Window Treatments Affordable`}
        description={`Your trusted source for affordable premium window treatments in the greater Los Angeles, Las Vegas, and Portland areas. Contact us today!`}
        canonicalUrl={`https://www.sunbowshades.com`}
      />
      <main id='home_container'>
        <div className='cover_photo' alt='cover_photo'>
          <h1 className='slogan'>
            Where Quality and Comfort Meets Style in Every Window
          </h1>
        </div>
        {
          isMobile ? (
            <>
              <h3 className='subheader'>
                Modern. Stylish. Affordable.&nbsp;
              </h3>
              <h3 className='subheader'>
                <a href='#consultation_anchor'>Contact a local expert today!</a>
              </h3>
            </>
          )
            :
            (
              <>
                <h3 className='subheader'>
                  Modern. Stylish. Affordable.&nbsp;
                  <a href='#consultation_anchor'>Contact a local expert today!</a>
                </h3>
              </>
            )
        }
        <Suspense fallback={<Loading />}>
          <Showcase isMobile={isMobile} />
          <Quality isMobile={isMobile} />
          <CommercialShowcase isMobile={isMobile} />
          <Consultation isMobile={isMobile} />
        </Suspense>
      </main>
    </>
  );
};

export default Home;
